import BpkDivider from '@skyscanner-internal/backpack-web/bpk-component-divider';
import {
  BpkBox,
  BpkSpacing,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';

const Separator = () => (
  <BpkBox
    marginTop={BpkSpacing.LG}
    marginBottom={BpkSpacing.LG}
    aria-hidden="true"
  >
    <BpkDivider />
  </BpkBox>
);

export default Separator;
